(function () {
  var cardSelector = '.product-card-revamp[data-combined-product-card]';
  var gallerySelector = '[data-product-card-gallery]';
  var instances = new WeakMap();

  function parseJson(script) {
    if (!script) {
      return null;
    }

    try {
      return JSON.parse(script.textContent || '[]');
    } catch (error) {
      return null;
    }
  }

  function getCombinedProducts(card) {
    var swatches = card.querySelector('[data-combined-product-swatches]');
    var script = swatches && swatches.querySelector('[data-combined-product-json]');
    var products = parseJson(script);

    return Array.isArray(products) ? products : [];
  }

  function buildImagesFromProduct(product) {
    if (!product) {
      return [];
    }

    if (Array.isArray(product.images) && product.images.length) {
      return product.images.filter(function (image) {
        return image && image.src;
      });
    }

    var images = [];

    if (product.featuredImage) {
      images.push({
        src: product.featuredImage,
        srcset: product.featuredSrcset || '',
        alt: product.title || ''
      });
    }

    if (product.secondaryImage) {
      images.push({
        src: product.secondaryImage,
        srcset: product.secondarySrcset || '',
        alt: product.title || ''
      });
    }

    return images;
  }

  function getImagesForCard(card, product) {
    if (product) {
      return buildImagesFromProduct(product);
    }

    var selectedId = card.getAttribute('data-selected-product-id');
    var products = getCombinedProducts(card);
    var matched = products.find(function (item) {
      return String(item.id) === String(selectedId);
    });

    if (matched) {
      return buildImagesFromProduct(matched);
    }

    if (products[0]) {
      return buildImagesFromProduct(products[0]);
    }

    var fallback = parseJson(card.querySelector('[data-product-card-gallery-json]'));
    return Array.isArray(fallback) ? fallback.filter(function (image) {
      return image && image.src;
    }) : [];
  }

  function getPrimaryImage(gallery) {
    var stage = gallery.querySelector('[data-product-card-gallery-stage]');

    if (!stage) {
      return null;
    }

    var images = stage.querySelectorAll('img');

    for (var i = 0; i < images.length; i++) {
      if (!images[i].closest('[data-product-card-gallery-secondary]')) {
        return images[i];
      }
    }

    return null;
  }

  function getSecondaryImage(gallery) {
    var secondary = gallery.querySelector('[data-product-card-gallery-secondary] img, [data-product-card-gallery-secondary-img]');
    return secondary;
  }

  function setImageSource(image, data) {
    if (!image || !data || !data.src) {
      return;
    }

    image.src = data.src;
    image.removeAttribute('data-src');

    if (data.srcset) {
      image.srcset = data.srcset;
      image.removeAttribute('data-srcset');
    } else {
      image.removeAttribute('srcset');
    }

    if (data.alt != null) {
      image.alt = data.alt;
    }

    if (data.width) {
      image.setAttribute('width', data.width);
    }

    if (data.height) {
      image.setAttribute('height', data.height);
    }
  }

  function updateNav(instance) {
    var nav = instance.nav;
    var prev = instance.prev;
    var next = instance.next;
    var total = instance.images.length;
    var index = instance.index;
    var arrowsEnabled = instance.gallery.getAttribute('data-gallery-arrows') !== 'false';

    if (!arrowsEnabled || !nav || !prev || !next) {
      if (nav) {
        nav.hidden = true;
      }
      return;
    }

    if (total < 2) {
      nav.hidden = true;
      prev.disabled = true;
      next.disabled = true;
      prev.setAttribute('aria-hidden', 'true');
      next.setAttribute('aria-hidden', 'true');
      return;
    }

    nav.hidden = false;
    prev.disabled = index <= 0;
    next.disabled = index >= total - 1;
    prev.hidden = index <= 0;
    next.hidden = index >= total - 1;
    prev.setAttribute('aria-hidden', index <= 0 ? 'true' : 'false');
    next.setAttribute('aria-hidden', index >= total - 1 ? 'true' : 'false');
  }

  function updateDots(instance) {
    var dots = instance.dots;
    var total = instance.images.length;
    var index = instance.index;
    var dotsEnabled = instance.gallery.getAttribute('data-gallery-dots') !== 'false';

    if (!dots || !dotsEnabled) {
      if (dots) {
        dots.hidden = true;
      }
      return;
    }

    if (total < 2) {
      dots.hidden = true;
      dots.innerHTML = '';
      return;
    }

    dots.hidden = false;

    if (dots.childElementCount !== total) {
      var html = '';

      for (var i = 0; i < total; i++) {
        html += '<button type="button" class="product-card-revamp__gallery-dot" data-product-card-gallery-dot data-index="' + i + '" aria-label="Show image ' + (i + 1) + ' of ' + total + '" role="tab"></button>';
      }

      dots.innerHTML = html;
    }

    Array.prototype.forEach.call(dots.children, function (dot, dotIndex) {
      var isActive = dotIndex === index;
      dot.classList.toggle('is-active', isActive);
      dot.setAttribute('aria-selected', isActive ? 'true' : 'false');
    });
  }

  function updateHoverLayer(instance) {
    var secondaryWrap = instance.gallery.querySelector('[data-product-card-gallery-secondary]');
    var media = instance.card.querySelector('.product-card-revamp__media');
    var canHover = instance.images.length > 1 && instance.index === 0 && !window.matchMedia('(hover: none)').matches;

    if (secondaryWrap) {
      if (canHover) {
        setImageSource(instance.secondaryImage, instance.images[1]);
        secondaryWrap.hidden = false;
        secondaryWrap.removeAttribute('hidden');
      } else {
        secondaryWrap.hidden = true;
      }
    }

    if (media) {
      media.classList.toggle('has-hover-image', canHover);
    }
  }

  function showIndex(instance, nextIndex, options) {
    options = options || {};
    var total = instance.images.length;

    if (!total) {
      return;
    }

    nextIndex = Math.max(0, Math.min(total - 1, nextIndex));

    if (nextIndex === instance.index && !options.force) {
      updateNav(instance);
      updateDots(instance);
      updateHoverLayer(instance);
      return;
    }

    var imageData = instance.images[nextIndex];
    var primary = instance.primaryImage;

    if (!primary || !imageData) {
      return;
    }

    instance.index = nextIndex;

    if (options.animate === false) {
      setImageSource(primary, imageData);
      instance.gallery.classList.remove('is-transitioning');
    } else {
      instance.gallery.classList.add('is-transitioning');
      window.requestAnimationFrame(function () {
        setImageSource(primary, imageData);
        window.setTimeout(function () {
          instance.gallery.classList.remove('is-transitioning');
        }, 250);
      });
    }

    updateNav(instance);
    updateDots(instance);
    updateHoverLayer(instance);
  }

  function createInstance(card) {
    var gallery = card.querySelector(gallerySelector);

    if (!gallery) {
      return null;
    }

    var existing = instances.get(card);

    if (existing) {
      return existing;
    }

    var instance = {
      card: card,
      gallery: gallery,
      nav: card.querySelector('[data-product-card-gallery-nav]'),
      prev: card.querySelector('[data-product-card-gallery-prev]'),
      next: card.querySelector('[data-product-card-gallery-next]'),
      dots: card.querySelector('[data-product-card-gallery-dots]'),
      primaryImage: getPrimaryImage(gallery),
      secondaryImage: getSecondaryImage(gallery),
      images: [],
      index: 0
    };

    instances.set(card, instance);
    return instance;
  }

  function setGalleryImages(card, product, options) {
    var instance = createInstance(card);

    if (!instance) {
      return;
    }

    instance.primaryImage = getPrimaryImage(instance.gallery) || instance.primaryImage;
    instance.secondaryImage = getSecondaryImage(instance.gallery) || instance.secondaryImage;
    instance.nav = card.querySelector('[data-product-card-gallery-nav]') || instance.nav;
    instance.prev = card.querySelector('[data-product-card-gallery-prev]') || instance.prev;
    instance.next = card.querySelector('[data-product-card-gallery-next]') || instance.next;
    instance.dots = card.querySelector('[data-product-card-gallery-dots]') || instance.dots;
    instance.images = getImagesForCard(card, product);
    instance.index = 0;

    showIndex(instance, 0, {
      force: true,
      animate: options && options.animate === true
    });
  }

  function stepGallery(card, direction) {
    var instance = instances.get(card) || createInstance(card);

    if (!instance || instance.images.length < 2) {
      return;
    }

    var nextIndex = instance.index + direction;

    if (nextIndex < 0 || nextIndex >= instance.images.length) {
      return;
    }

    showIndex(instance, nextIndex, { animate: true });
  }

  function initCard(card) {
    setGalleryImages(card, null, { animate: false });
  }

  function initCards(root) {
    var scope = root || document;

    scope.querySelectorAll(cardSelector).forEach(function (card) {
      initCard(card);
    });
  }

  document.addEventListener('click', function (event) {
    var prev = event.target.closest('[data-product-card-gallery-prev]');
    var next = event.target.closest('[data-product-card-gallery-next]');
    var dot = event.target.closest('[data-product-card-gallery-dot]');

    if (!prev && !next && !dot) {
      return;
    }

    var card = event.target.closest(cardSelector);

    if (!card) {
      return;
    }

    event.preventDefault();
    event.stopPropagation();

    if (dot) {
      var instance = instances.get(card) || createInstance(card);
      var dotIndex = parseInt(dot.getAttribute('data-index'), 10);

      if (instance && !isNaN(dotIndex)) {
        showIndex(instance, dotIndex, { animate: true });
      }
      return;
    }

    if ((prev && prev.disabled) || (next && next.disabled)) {
      return;
    }

    stepGallery(card, prev ? -1 : 1);
  }, true);

  document.addEventListener('keydown', function (event) {
    if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') {
      return;
    }

    var card = event.target.closest(cardSelector);

    if (!card || !event.target.closest('[data-product-card-gallery-nav], [data-product-card-gallery]')) {
      return;
    }

    event.preventDefault();
    stepGallery(card, event.key === 'ArrowLeft' ? -1 : 1);
  });

  window.ProductCardGallery = {
    initCards: initCards,
    setImages: setGalleryImages,
    reset: function (card, product) {
      setGalleryImages(card, product, { animate: false });
    }
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initCards(document);
    });
  } else {
    initCards(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    initCards(event.target);
  });

  document.addEventListener('collection:reloaded', function () {
    initCards(document);
  });

  document.addEventListener('limoniapps:discountninja:collection:productsadded', function () {
    initCards(document);
  });

  document.addEventListener('recommendations:loaded', function (event) {
    initCards(event.detail && event.detail.section ? event.detail.section : document);
  });
})();
